import { render } from "./CanvasPreview.vue?vue&type=template&id=76ab8b77"
import script from "./CanvasPreview.vue?vue&type=script&lang=js"
export * from "./CanvasPreview.vue?vue&type=script&lang=js"
script.render = render

export default script